import api from "../api";
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    bankData: {},
    access: {},
    updateBank: {},
    deleteBank: {}
  },
  getters: {
    
  },
  actions: {

    async get_bankDatas({ commit }) {
      try {
        api.get("/v1/bank")
          .then((res) => {
            commit("GET_BANKDATAS", res.data);
          })
          .catch((error) => {
            commit("ERROR_BANK", "Erro ao carregar");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_BANK", e);
      }
    },

    async create_access({ commit }, company_id) {
      try {
        api.post("/v1/bankData/generate-access", {company_id})
        .then((res) => {
          commit("GET_ACCESS", res.data);
        })
        .catch((error) => {
          commit("ERROR_ACCESS", error);
        })
        .finally(() => (
          // this.loading = false
          console.log('login request end')
        ));
      } catch (e) {
        commit("ERROR_ACCESS", e);
      }
    },   

    async add_bank({ commit }, payload = []) {
      try {
        return await api.post("/v1/bankData/add_bank", payload)
          .then((res) => {
            // commit("GET_ADD_BANK", res?.data);
            console.log(res?.data)
            if(res?.data?.error){
              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
            }else{
            
              toast.success(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
              
            }
            return res?.data;
            
          })
          .catch((error) => {
            commit("ERROR_ADD_BANK", "Erro ao carregar");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ADD_BANK", e);
      }
    },

    async upt_bank({ commit }, payload = []) {
      try {
        return await api.post("/v1/bankData/upt_bank", payload)
          .then((res) => {
            console.log(res?.data)
            if(res?.data?.error){
              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
            }else{
            
              toast.success(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
              
            }
            return res?.data;
          })
          .catch((error) => {
            commit("ERROR_UPT", error);
            toast.warning("Erro ao alterar", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_UPT", e);
      }
    },

    async del_bank({ commit }, payload = []) {
      try {
        const res = await api.post("/v1/bankData/del_bank", payload);
        commit("GET_DEL", res.data);
        toast.success("Excluído com sucesso", {
          type: 'default',
          theme: 'colored',
          hideProgressBar: true,
          dangerouslyHTMLString: true
        });
        return res.data;
      } catch (error) {
        commit("ERROR_DEL", error);
        toast.warning(
          error.response?.data?.Erro || "Erro ao excluir",
          {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          }
        );
        throw error; // <-- Aqui o erro é repassado para quem chamou a action
      } finally {
        console.log('delete request end');
      }
    },
    
  },
  mutations: {
    GET_BANKDATAS(state, data) {
      state.bankData = data; 
    },
    ERROR_BANK(state, data) {
      console.log(data);
    },

    GET_ACCESS(state, data) {
      state.access = data; 
    },
    ERROR_ACCESS(state, data) {
      console.log(data);
    },

    GET_ADD_BANK(state, data) {
      state.bankData = data; 
    },
    ERROR_ADD_BANK(state, data) {
      console.log(data);
    },

    GET_UPT(state, data) {
      state.updateBank = data; 
    },
    ERROR_UPT(state, data) {
      console.log(data);
    },

    GET_DEL(state, data) {
      state.deleteBank = data; 
    },
    ERROR_DEL(state, data) {
      console.log(data);
    },
  }
}